import { render, staticRenderFns } from "./Scroller.vue?vue&type=template&id=541cf94d&scoped=true"
import script from "./Scroller.vue?vue&type=script&lang=js"
export * from "./Scroller.vue?vue&type=script&lang=js"
import style0 from "./Scroller.vue?vue&type=style&index=0&id=541cf94d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541cf94d",
  null
  
)

export default component.exports